/**
 * "Has this browser finished the training course?" (ROUND7 §5). The title puts TRAINING first, with "NEW? START
 * HERE", until it has. A plain localStorage flag and deliberately NOT part of the profile save: it is about this
 * browser's player, not his company, and keeping it out of the save means no migration and nothing for the cloud
 * sync to carry. Every access is guarded - a private window or a blocked store simply never remembers.
 */

export const TRAINING_DONE_KEY = 'nightdrop.trainingDone';

export function trainingDone(): boolean {
  try {
    return window.localStorage.getItem(TRAINING_DONE_KEY) === '1';
  } catch {
    return false;
  }
}

export function markTrainingDone(): void {
  try {
    window.localStorage.setItem(TRAINING_DONE_KEY, '1');
  } catch {
    // Not remembered: the title keeps offering the course first, which is harmless.
  }
}
